import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteAssistantID,
  getAllAssistant,
  getAssistantFetchExternal,
  updateAssistant
} from "../../utils/api/assistantAPI";

const initialState = {
  value: [],
  status: "idle",
  error: null,
  activeDetail: {},
  updateData: {},
  detailStatus: "idle",
  detailError: null,
};

// Fetch all assistants
export const fetchAssistants = createAsyncThunk(
  "assistants/fetchAssistants",
  async (userOrgId, { rejectWithValue }) => {
    try {
      const data = await getAllAssistant(userOrgId);
      return data?.assistants || [];
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch assistants");
    }
  }
);

// Fetch a specific assistant's details
export const fetchAssistantDetail = createAsyncThunk(
  "assistants/fetchAssistantDetail",
  async (assistantId, { rejectWithValue }) => {
    try {
      const detail = await getAssistantFetchExternal(assistantId);
      // console.log(detail)

      
      return detail;

    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch assistant detail");
    }
  }
);

// Update assistant detail
export const saveAssistantDetail = createAsyncThunk(
  "assistants/updateAssistantDetail",
  async ({ assistantId, userOrgId }, { rejectWithValue, getState, dispatch }) => {
    try {
      const { updateData } = getState().assistants;

      const response = await updateAssistant(assistantId, updateData);

      // Refetch updated detail
      await dispatch(fetchAssistantDetail(assistantId));

      // Optional: If update affects list view
      await dispatch(fetchAssistants(userOrgId));

      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Failed to update assistant");
    }
  }
);



// Delete an assistant
export const deleteAssistant = createAsyncThunk(
  "assistants/deleteAssistant",
  async ({ assistantId }, { rejectWithValue }) => {
    try {
      const response = await deleteAssistantID(assistantId);
      return response;
    } catch (e) {
      return rejectWithValue(e.message || "Failed to delete assistant");
    }
  }
);

const assistantSlice = createSlice({
  name: "assistants",
  initialState,
  reducers: {
    // Append/merge new data into activeDetail
    appendToAssistantDetail: (state, action, ) => {
      state.updateData = {
       
        ...action.payload
      };
    },
  },
  extraReducers: (builder) => {
    builder

      // Fetch Assistants
      .addCase(fetchAssistants.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAssistants.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.value = action.payload;
        
      })
      .addCase(fetchAssistants.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error.message;
      })

      // Fetch Assistant Detail
      .addCase(fetchAssistantDetail.pending, (state) => {
        state.detailStatus = "loading";
      })
      .addCase(fetchAssistantDetail.fulfilled, (state, action) => {
        state.detailStatus = "succeeded";
        state.activeDetail = action.payload || {};


      })
      .addCase(fetchAssistantDetail.rejected, (state, action) => {
        state.detailStatus = "failed";
        state.detailError = action.payload || action.error.message;
      })

      // Save Assistant Detail
      .addCase(saveAssistantDetail.pending, (state) => {
        state.detailStatus = "saving";
        state.detailError = null;
      })
      .addCase(saveAssistantDetail.fulfilled, (state, action) => {
        state.detailStatus = "saved";
        state.activeDetail = {
          ...state.activeDetail,
          ...action.payload.details,
        };
      })
      .addCase(saveAssistantDetail.rejected, (state, action) => {
        state.detailStatus = "failed";
        state.detailError = action.payload || action.error.message;
      })

      // Delete Assistant
      .addCase(deleteAssistant.pending, (state) => {
        state.status = "deleting";
        state.error = null;
      })
      .addCase(deleteAssistant.fulfilled, (state, action) => {
        state.status = "deleted";
        state.activeDetail = { id: null };
        state.value = state.value.filter(
          (item) => item.id !== action.meta.arg.assistantId
        );
      })
      .addCase(deleteAssistant.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error.message;
      });
  },
});

// Export reducer actions and slice
export const { appendToAssistantDetail } = assistantSlice.actions;
export default assistantSlice.reducer;
